import { makeProjectController } from "@controllers/project";
import { makeTaskController } from "@controllers/task";
import { makeRenderer } from "@views/renderer";
import { THEME } from "./constants";
export function init(doc) {
    try {
        const projectController = makeProjectController();
        projectController.fetchProjects("localStorage");
        const taskController = makeTaskController();
        taskController.fetchTasks("localStorage");
        const settings = localStorage.getItem("tbSettings")
            ? JSON.parse(localStorage.getItem("tbSettings"))
            : { theme: THEME.GREEN, jank: true };
        const renderer = makeRenderer(doc.getElementById("app"), taskController, projectController, settings);
        renderer.renderPage(doc.getElementById("app"));
    }
    catch (error) {
        console.error(error);
    }
}
